/*
 * Card de produto 034 — compra rápida (desktop, hover/foco).
 * - Delegação no document: funciona em cards renderizados depois (filtros AJAX,
 *   carregar mais, recomendações, vitrine por categoria).
 * - Adiciona via /cart/add.js pedindo as seções do carrinho e dispara o mesmo
 *   evento que o Horizon usa ('cart:update'), que atualiza e abre o carrinho
 *   lateral e o contador do header.
 * - Textos de status vêm dos data-attributes do card (settings do tema).
 */
(function () {
  if (window.Outlet034QuickAdd) return;
  window.Outlet034QuickAdd = true;

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function setStatus(quick, text, isError) {
    var status = quick.querySelector('.pc034__quick-status');
    if (!status) return;
    status.textContent = text || '';
    status.style.color = isError ? '#b42318' : '';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.pc034__quick [data-variant-id]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var quick = btn.closest('.pc034__quick');
    if (!quick || quick.classList.contains('is-busy')) return;
    quick.classList.add('is-busy');
    setStatus(quick, '');

    var ids = sectionIds();
    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (ids.length) body.sections = ids.join(',');

    fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function (data) {
        return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { added: data, cart: cart }; })
          .catch(function () { return { added: data, cart: null }; });
      })
      .then(function (result) {
        setStatus(quick, quick.dataset.addedLabel || '');
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: result.cart || {},
              sourceId: quick.closest('.pc034') ? quick.closest('.pc034').dataset.productId : '',
              data: {
                source: 'product-card-034',
                itemCount: result.cart ? result.cart.item_count : undefined,
                variantId: btn.dataset.variantId,
                sections: (result.added && result.added.sections) || {},
              },
            },
          })
        );
        var drawer = document.querySelector('cart-drawer-component');
        // Com "Abrir carrinho automaticamente" ligado, o próprio carrinho já abre no evento.
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) {
          setTimeout(function () { drawer.open(); }, 120);
        }
        setTimeout(function () { setStatus(quick, ''); }, 2200);
      })
      .catch(function (err) {
        setStatus(quick, (err && err.message) || quick.dataset.errorLabel || '', true);
      })
      .then(function () {
        quick.classList.remove('is-busy');
      });
  });
})();

/*
 * Card de produto 034 — miniaturas de cor (foto da variante).
 * Mouse em cima da miniatura: a foto principal do card mostra aquela cor; ao
 * sair do card, volta a foto original. Toque/clique segue o link da variante.
 * Delegação no document: vale para cards renderizados depois.
 */
(function () {
  if (window.Outlet034Swatches) return;
  window.Outlet034Swatches = true;

  function primaryOf(card) {
    return card && card.querySelector('.pc034__img--primary');
  }

  function show(sw) {
    var card = sw.closest('.pc034');
    var img = primaryOf(card);
    if (!img || !sw.dataset.src) return;
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
    if (sw.dataset.srcset) img.setAttribute('srcset', sw.dataset.srcset);
    img.setAttribute('src', sw.dataset.src);
    img.removeAttribute('loading');
    card.querySelectorAll('[data-pc034-swatch].is-active').forEach(function (a) { if (a !== sw) a.classList.remove('is-active'); });
    sw.classList.add('is-active');
    card.classList.add('pc034--swatch-preview');
  }

  function reset(card) {
    var img = primaryOf(card);
    if (!img || !img.dataset.origSrc) return;
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', img.dataset.origSrc);
    card.querySelectorAll('[data-pc034-swatch].is-active').forEach(function (a) { a.classList.remove('is-active'); });
    card.classList.remove('pc034--swatch-preview');
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest && e.target.closest('[data-pc034-swatch]');
    if (sw) show(sw);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('.pc034');
    if (!card || !card.classList.contains('pc034--swatch-preview')) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    reset(card);
  });

  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('[data-pc034-swatch]');
    if (sw) show(sw);
  });
})();
